import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

interface ReindexElapsedTimeProps {
  startedAt: string;
  className?: string;
}

const formatElapsed = (startedAt: string) => {
  const seconds = Math.max(
    0,
    Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000),
  );
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
};

export default function ReindexElapsedTime({
  startedAt,
  className,
}: ReindexElapsedTimeProps) {
  const intl = useIntl();
  const [elapsed, setElapsed] = useState(() => formatElapsed(startedAt));

  useEffect(() => {
    setElapsed(formatElapsed(startedAt));
    const timer = setInterval(() => setElapsed(formatElapsed(startedAt)), 1000);
    return () => clearInterval(timer);
  }, [startedAt]);

  return (
    <span className={className}>
      {intl.formatMessage(
        {
          id: "header.productReindexRunning",
          defaultMessage: "Reindexing… {elapsed}",
        },
        { elapsed },
      )}
    </span>
  );
}
